import EditorVMBase from "../../../../Lib/Fs.SmartClient.Client/EditorVMBase";
import { ValidationRules, ValidationController, validateTrigger } from "aurelia-validation";
import FsUtility from "../../../../Lib/Fs.SmartClient.Client/FsUtility";
import { useView, autoinject, Container, computedFrom } from 'aurelia-framework';
import InformationEditorVM from "./InformationEditorVM";
import { fs } from "../../../../Config/FsConfig";
import { PLATFORM } from 'aurelia-pal';

@autoinject
@useView(PLATFORM.moduleName("./UserDetailView.html"))
export default class UserDetailEditorVM extends EditorVMBase {
    Code: string;

    InformationEditorVM: InformationEditorVM;

    constructor() {
        super();

    }

    activate(params) {
        this.Load(params.id);
    }

    Load(code: string) {
        var self = this;
        if (code != null && code != 'undefined') {
            self.Code = code;
            self.PrepareChildVMs();
        } else {
            this.BeginEdit();
            self.InformationEditorVM = new InformationEditorVM(null);
        }
    };

    Back(): void {
        window.location.href = fs.Config.ClientBaseUrl + "Modules/Core/ManageUserPage";
    }

    PrepareChildVMs() {
        super.PrepareChildVMs();

        if (this.Code != null && this.Code != "" && this.Code != undefined && this.Code != "00000000-0000-0000-0000-000000000000") {
            this.AddChildNode(new InformationEditorVM(this.Code));
            this.InformationEditorVM = this.ChildNodeGroups["default"][0];
        }
    }
}
